// Hint catalog. The `id` is the stable localStorage dedup key — never rename it
// once published, or existing players will see the hint again. The `stringKey`
// is the i18n key for the displayed text and may be edited freely.
export const Hints = {
	HOW_TO_WAIT: { id: "howToWait", stringKey: "hint_howToWait" },
	DESTROY_PORTALS: { id: "destroyPortals", stringKey: "hint_destroyPortals" },
	AUTO_SHOOT: { id: "autoShoot", stringKey: "hint_autoShoot" },
} as const;
